import { TaskSourceRef } from "src/api/generated/tasks/taskSource/taskSourceRef.ts";
import { TaskSourceType } from "src/api/generated/postgres/db/types/tasks/enums/taskSourceType.ts";

export const stringifyTaskSource = (taskSource: TaskSourceRef): string => {
	return JSON.stringify({
		sourceType: taskSource.sourceType,
		sourceId: taskSource.sourceId,
	});
};

export const stringifyTaskSourceNullable = (
	taskSource: TaskSourceRef | null | undefined,
): string | null => {
	if (taskSource == null) return null;

	return stringifyTaskSource(taskSource);
};

export const nullableTaskSourceRef = (
	sourceType: TaskSourceType | undefined | null,
	sourceId: number | undefined | null,
): TaskSourceRef | null => {
	if (sourceType == null || sourceId == null) return null;

	return {
		sourceType,
		sourceId,
	};
};
